/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { SystemVarsRestService } from '@gh/builder-shared-data';
import { InitViewService } from '@gh/common-shared';
import { Observable } from 'rxjs';
import { SystemVarsLedger } from './model/system-vars-ledger.model';

@Injectable()
export class SystemVarsLedgerTabBusinessService implements InitViewService {
  constructor(private restService: SystemVarsRestService) {
  }

  initView(): any {
    return {
      ledgerSystemVariables: this.get(),
    };
  }

  get(): Observable<SystemVarsLedger> {
    return this.restService.getLedger();
  }

  update(ledger: SystemVarsLedger): Observable<SystemVarsLedger> {
    return this.restService.updateLedger(ledger);
  }
}
